import { detectBrowser } from './utils';
import axios from 'axios';
import { v4 } from 'uuid';
import isPropValid from '@emotion/is-prop-valid';
import { Runtime, StyledTarget } from 'styled-components/dist/types';

const { name, version } = detectBrowser();

const defaultOptions = {
  headers: {
    browser_url: window.location.href,
    browser_name: name,
    browser_version: version,
    browser_language: window.navigator.language,
    x_request_id: v4(),
  },
};

// Create instance
export const axiosInstance = axios.create(defaultOptions);

export function shouldForwardProp<R extends Runtime>(
  propName: string,
  target: StyledTarget<R>,
) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}
